import { fromJS, List } from 'immutable';
import { mergeEntity, normalizeEntities } from 'helpers/utilHelpers';

import {
  CREATE_PROJECT_CLIENT_SUCCESS,
  DELETE_CLIENT_PAYMENT_SUCCESS,
  DELETE_CLIENT_SUCCESS,
  INVITE_USER_CLIENT_SUCCESS,
  LOAD_CLIENT_BY_ID_SUCCESS,
  LOAD_CLIENT_PAYMENTS_SUCCESS,
  LOAD_CLIENTS_SUCCESS,
  LOAD_PROJECT_BY_ID_SUCCESS,
  LOAD_PROJECTS_SERVICES_MAP_SUCCESS,
  LOAD_PROJECTS_SUCCESS,
  UPDATE_CLIENT_PAYMENT_SUCCESS,
  UPDATE_CLIENT_SUCCESS,
  UPDATE_LEGAL_ENTITY_SUCCESS,
  CREATE_USER_CLIENT_SUCCESS,
  LOAD_CLIENTS_TABLE_SUCCESS,
  LOAD_CLIENT_INVOICE_SUCCESS,
  LOAD_CLIENT_INVOICES_TABLE_SUCCESS,
  UPDATE_CLIENT_INVOICE_SUCCESS,
  DELETE_CLIENT_INVOICE_SUCCESS,
  LOAD_CLIENT_INVOICE_BY_ID_SUCCESS,
} from 'constants/ActionTypes';

const initialState = fromJS({
  clients: {},
  clientPayments: {},
  clientInvoices: {},
});

/**
 * Function for change array field: `projects`, `clientProfiles` and `entities` in client company
 * @param client
 * @return new client
 */
const prepareClient = (client) => {
  if (client.projects) {
    client.projects = client.projects.map((project) => project.projectId);
  }

  if (client.clientProfiles) {
    client.clientProfiles = client.clientProfiles.map((profile) => profile.userId);
  }

  if (client.entities) {
    client.entities = client.entities.map((entity) => entity.entityId);
  }
  return client;
};

const prepareInvoice = (invoice) => {
  if (invoice.clientEntity) {
    delete invoice['clientEntity'];
  }
  return invoice;
};

const clientsReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_CLIENT_PAYMENTS_SUCCESS:
      return state.set(
        'clientPayments',
        normalizeEntities(action.clientPayments.items, 'invoiceId', state.get('clientPayments')),
      );
    case LOAD_CLIENTS_TABLE_SUCCESS:
    case LOAD_CLIENTS_SUCCESS: {
      const clients = action.clients.items.map((client) => prepareClient({ ...client }));
      return state.set('clients', normalizeEntities(clients, 'companyId', state.get('clients')));
    }
    case LOAD_PROJECTS_SUCCESS: {
      const clients = [];
      action.projects.items.forEach((project) => {
        project.client && clients.push(prepareClient({ ...project.client }));
      });

      return state.set('clients', normalizeEntities(clients, 'companyId', state.get('clients')));
    }
    case LOAD_PROJECTS_SERVICES_MAP_SUCCESS: {
      const clients = [];
      action.projectsServicesMap.items.forEach((map) => {
        map.client && clients.push(prepareClient({ ...map.client }));
      });

      return state.set('clients', normalizeEntities(clients, 'companyId', state.get('clients')));
    }
    case LOAD_PROJECT_BY_ID_SUCCESS: {
      if (action.project.client) {
        const client = prepareClient({ ...action.project.client });
        return state.setIn(
          ['clients', client.companyId],
          mergeEntity(client, state.getIn(['clients', client.companyId])),
        );
      }

      return state;
    }
    case UPDATE_CLIENT_SUCCESS: {
      const client = prepareClient({ ...action.client });

      return state.setIn(
        ['clients', client.companyId],
        mergeEntity(client, state.getIn(['clients', client.companyId])),
      );
    }
    case CREATE_USER_CLIENT_SUCCESS:
      return state.setIn(
        ['clients', action.user.userProfile.clientId, 'clientProfiles'],
        state
          .getIn(['clients', action.user.userProfile.clientId, 'clientProfiles'])
          .push(action.user.userProfile.userId),
      );
    case UPDATE_CLIENT_PAYMENT_SUCCESS:
      return state.setIn(
        ['clientPayments', action.invoice.invoiceId],
        mergeEntity(action.invoice, state.getIn(['clientPayments', action.invoice.invoiceId])),
      );
    case CREATE_PROJECT_CLIENT_SUCCESS: {
      const client = prepareClient({ ...action.client });
      return state.setIn(
        ['clients', client.companyId],
        mergeEntity(client, state.getIn(['clients', client.companyId])),
      );
    }
    case DELETE_CLIENT_SUCCESS:
      return state.deleteIn(['clients', action.companyId]);
    case DELETE_CLIENT_PAYMENT_SUCCESS:
      return state.deleteIn(['clientPayments', action.invoiceId]);
    case LOAD_CLIENT_BY_ID_SUCCESS: {
      const client = { ...action.values };
      prepareClient(client);
      return state.setIn(
        ['clients', client.companyId],
        mergeEntity(client, state.getIn(['clients', client.companyId])),
      );
    }
    case INVITE_USER_CLIENT_SUCCESS: {
      const path = ['clients', action.values.clientId, 'clientProfiles'];
      if (state.getIn(path)?.includes(action.values.userId)) {
        return state;
      }

      return state.setIn(path, state.getIn(path, List()).push(action.values.userId));
    }
    case UPDATE_LEGAL_ENTITY_SUCCESS:
      if (action.entity.relatedEntity === 'client') {
        const exists = state.getIn(
          ['clients', action.entity.relatedEntityId, 'entities', action.entity.entityId],
          false,
        );
        if (!exists && state.getIn(['clients', action.entity.relatedEntityId, 'entities'])) {
          return state.setIn(
            ['clients', action.entity.relatedEntityId, 'entities'],
            state.getIn(['clients', action.entity.relatedEntityId, 'entities']).push(action.entity.entityId),
          );
        }
      }
      return state;
    case LOAD_CLIENT_INVOICE_SUCCESS:
    case LOAD_CLIENT_INVOICES_TABLE_SUCCESS:
      return state.set(
        'clientInvoices',
        normalizeEntities(action.invoices.items, 'invoiceId', state.get('clientInvoices')),
      );
    case LOAD_CLIENT_INVOICE_BY_ID_SUCCESS:
    case UPDATE_CLIENT_INVOICE_SUCCESS:
      return state.setIn(
        ['clientInvoices', action.invoice.invoiceId],
        mergeEntity(prepareInvoice({ ...action.invoice }), state.getIn(['clientInvoices', action.invoice.invoiceId])),
      );
    case DELETE_CLIENT_INVOICE_SUCCESS:
      return state.deleteIn(['clientInvoices', action.invoiceId]);
    default:
      return state;
  }
};

export default clientsReducer;
